import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Countdown, CountdownProps } from 'components/Countdown';

import { ScTimer } from './styled';

const SECONDS_IN_DAY = 86400;

export const TimerLabel: FC<Pick<CountdownProps, 'timeLeft'>> = ({
  timeLeft,
}) => {
  const { t } = useTranslation();

  const isDaysShown = useMemo(() => timeLeft > SECONDS_IN_DAY, [timeLeft]);

  return (
    <Countdown timeLeft={timeLeft < 0 ? 0 : timeLeft}>
      {({ days, hours, minutes, seconds }) => (
        <ScTimer>
          {isDaysShown && (
            <>
              <span>
                {days}
                {t('timer.dd')[0]}
              </span>
              <span>:</span>
            </>
          )}

          <span>
            {hours}
            {t('timer.hh')[0]}
          </span>
          <span>:</span>
          <span>
            {minutes}
            {t('timer.mm')[0]}
          </span>

          {!isDaysShown && (
            <>
              <span>:</span>
              <span>
                {seconds}
                {t('timer.ss')[0]}
              </span>
            </>
          )}
        </ScTimer>
      )}
    </Countdown>
  );
};
